import type { CompanyModel } from "models/company/entities/CompanyModel";
import React from "react";

export interface CompanyCardProps {
  company: CompanyModel
  onClick: (company: CompanyModel) => void;
}

const CompanyCard = (props: CompanyCardProps) => {
  const { company, onClick } = props;

  const handleClick = () => {
    onClick(company);
  };

  return (
    <div className="border-t first:border-t-0 ">
      <button className="w-full flex flex-row items-center rounded-md p-2 hover:bg-gray-200 transition-all" onClick={handleClick}>
        <img src={company.features.logo} alt="Logo empresa" width={52} height={52} className="mr-4 rounded-md" />
        <h3>{company.name}</h3>
      </button>
    </div>
  );
}

export default CompanyCard;